import apiFetch from '../apiFetch'

export default function (userId, dossierNumber) {
  return apiFetch({ endPoint: `Result?userId=${userId}&dossierNumber=${dossierNumber}`, method: 'GET', isHotFolder: true })
}
